<template>
<div class="chapter">
<div class="inner_page">
<p class="C277"><a id="page_XVII">DRAMATIS PERSONAE</a></p><a id="page_XVII">
<p class="C293"><strong>FAMILY</strong></p>
<p class="C904">James Bradford Pier (Uncle Pier)</p>
<p class="C904">Lu Merry Pier (Aunt Lu)</p>
<p class="C906"><em>Lucy’s mother’s sister</em></p>
<p class="C296">CHILDREN</p>
<p class="C908">Sarah Pier (Cousin Sarah)</p>
<p class="C908">Sammy Pier (Cousin Sammy)</p>
<p class="C906">Lu Pier Cochran (Cousin Lu)</p>
<p class="C296">SLAVES</p>
<p class="C906">Dick, Parrot, Winnie, Ellen</p>
<p class="C904">Waller Cochran (Cousin Waller)</p>
<p class="C904">Lu Cochran (Cousin Lu)</p>
<p class="C906"><em>Daughter of J. B. &amp; Lu Pier</em></p>
<p class="C296">SON</p>
<p class="C906">Willie Cochran</p>
<p class="C296">SLAVES</p>
<p class="C908">Catharine, Lucinda, Sally, Ike,</p>
<p class="C906">George, Rose, Beckie, Willis</p>
<p class="C904">Uncle Martin Merry</p>
<p class="C904">Aunt Hannah Merry</p>
<p class="C908"><em>Aunt Lu’s brother; Lucy’s</em></p>
<p class="C906"><em>mother’s brother</em></p>
<p class="C293"><strong>FRIENDS</strong></p>
<p class="C904">Mr. Bell &amp; Elizabeth Bell</p>
<p class="C908">Callie, Sack, Newt, Jane,</p>
<p class="C908">Shiloah, Sallie Lu</p>
<p class="C904">George Bell</p>
<p class="C904">Mr. &amp; Mrs. Brewer</p>
<p class="C908">Lissie, Mollie, Elizabeth,</p>
<p class="C908">Sallie Pier</p>
<p class="C904">Mr. &amp; Mrs. Buck</p>
<p class="C908">Bella</p>
<p class="C904">Mrs. Cameron</p>
<p class="C908">Artie, Willie</p>
<p class="C904">Mr. &amp; Mrs. Cyrus Campbell</p>
<p class="C908">Austin</p>
<p class="C904">Mr. &amp; Mrs. Rufus Campbell</p>
<p class="C908">Sarah</p>
<p class="C904">Mr. &amp; Mrs. Catlin</p>
<p class="C908">Sallie Lou, Todie, Sukie</p>
<p class="C904">Mr. &amp; Mrs. Chapman</p>
<p class="C908">Charley</p>
<p class="C904">Mrs. Clemmons</p>
<p class="C908">Sallie, Jimmy</p>
<p class="C904">Mr. &amp; Mrs. Cleveland</p>
<p class="C908">Annie, Caroline</p>
<p class="C904">Mrs. Cochran</p>
<p class="C908">Nehemiah (Neh), Emma,</p>
<p class="C908">Jimmie, Mollie, Tallie</p>
<p class="C904">“Uncle” Jimmy Cochran</p>
</a><p class="C904"><a id="page_XVII"></a><a id="page_XVIII">Mr. &amp; Mrs. Darnman Lulu</a></p><a id="page_XVIII">
<p class="C904">Lydia Francis</p>
<p class="C904">Anson Harvey</p>
<p class="C904">Lissie Jackson</p>
<p class="C904">Sallie Kavanaugh</p>
<p class="C904">Kate Kenney, Sue Kenney</p>
<p class="C904">Dentist Lee</p>
<p class="C904">Mr. &amp; Mrs. LottEmily</p>
<p class="C904">Dr. &amp; Mrs. McLarin Sallie, Bolie, Sue, Fannie</p>
<p class="C904">Mollie McNeese</p>
<p class="C904">Mr. &amp; Mrs. Middleton</p>
<p class="C904">Annie Roach</p>
<p class="C904">Bracey Roach</p>
<p class="C904">Mrs. S</p>
<p class="C908">Joe, Ruf, &amp; Ino Campbell</p>
<p class="C904">Grandma Swearingen</p>
<p class="C904">Sallie Swearingen</p>
<p class="C904">Sallie T.</p>
<p class="C904">Sis Torrence</p>
<p class="C904">Tom</p>
<p class="C904">Sue Wilson</p>
<p class="C293"><strong>SOLDIER BOYS</strong></p>
<p class="C904">George Bell</p>
<p class="C904">Joe Blakley</p>
<p class="C904">Harry Bracey</p>
<p class="C904">Benton Brewer</p>
<p class="C904">Rufus Brewer</p>
<p class="C904">Jim Brewer</p>
<p class="C904">William Brewer</p>
<p class="C904">Trav C</p>
<p class="C904">Cy Campbell</p>
<p class="C904">Joe Campbell (died)</p>
<p class="C904">Ino Campbell</p>
<p class="C904">Mack Campbell</p>
<p class="C904">Jake Catlin</p>
<p class="C904">Mr. Chesley (former teacher/Travis)</p>
<p class="C904">Jimmy Clemmons</p>
<p class="C904">Nehemiah (Neh) Cochran</p>
<p class="C904">Jack Cochran (died)</p>
<p class="C904">Hez Collins</p>
<p class="C904">Kinch Collins</p>
<p class="C904">Ino E</p>
<p class="C904">Billy Fordtran</p>
<p class="C904">Stickney Fowler (died)</p>
<p class="C904">Jimmy Francis (died)</p>
<p class="C904">John Harvey</p>
<p class="C904">Ino Harvey</p>
<p class="C904">Captain Hunt</p>
<p class="C904">Martin Kenny</p>
<p class="C904">Nick Merry (deserted)</p>
<p class="C904">Robert Minton</p>
<p class="C904">Sammy Pier</p>
<p class="C904">Charlie Uckert</p>
<p class="C904">Henry P. Wiley</p>
</a><p class="C293"><a id="page_XVIII"><strong></strong></a><strong><a id="page_XIX">ACQUAINTANCES</a></strong></p><a id="page_XIX">
<p class="C904">Marion Adams</p>
<p class="C904">Captain S. Adkins (aboard the <em>Fox</em>)</p>
<p class="C904">“Aunt” Violet &amp; “Uncle” Frank (lost home in fire)</p>
<p class="C904">Lieut. Baldwin (visiting Havana)</p>
<p class="C904">Mr. Baldwin &amp; Bessie (friends of Uncle Martin)</p>
<p class="C904">Mr. &amp; Mrs. Harry Bracey</p>
<p class="C904">Mr. &amp; Mrs. Bush (residents of Hempstead)</p>
<p class="C904">Mrs. George Chambers (friend of Mrs. Peebles)</p>
<p class="C904">Mrs. Clark (friend of Mrs. Peebles)</p>
<p class="C904">Dr. &amp; Mrs. Cocke, Willie</p>
<p class="C904">Louise (a slave)</p>
<p class="C904">Mrs. Day, Fanny</p>
<p class="C904">Mr. Dunn</p>
<p class="C904">Mrs. Fadi (resident of Hempstead)</p>
<p class="C904">Mr. Ferris (resident of Galveston)</p>
<p class="C904">Mr. &amp; Mrs. Billy Francis (lived near Cousin Lu)</p>
<p class="C904">Mr. Groves (resident of Hempstead)</p>
<p class="C904">Mr. Joseph Hendley (Galveston)</p>
<p class="C904">Mr. William Hendley (Galveston)</p>
<p class="C904">Parson Kenney</p>
<p class="C904">Mr. Linn</p>
<p class="C904">Mr. &amp; Mrs. Mason (residents of Galveston)</p>
<p class="C904">Miss McHenry</p>
<p class="C904">Mr. &amp; Mrs. Jim Middleton</p>
<p class="C904">Jennie Minton</p>
<p class="C904">Mr. Murdock (aboard the <em>Fox</em>)</p>
<p class="C904">Mrs. Paine</p>
<p class="C904">Dr. &amp; Mrs. Peebles</p>
<p class="C904">Maggie, Rachel, Samie</p>
<p class="C904">Mr. &amp; Mrs. Pilley</p>
<p class="C904">Mrs. Purcell, Sue</p>
<p class="C904">Dr. &amp; Mrs. Richie</p>
<p class="C904">Mrs. Scranton (resident of Galveston)</p>
<p class="C904">Mr. John Sleight (Galveston)</p>
<p class="C904">Miss Mary Smith</p>
<p class="C904">Bell Snood</p>
<p class="C904">Mrs. Stevens, Ella</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Dramatis_Personae.vue?0b35685a